import { resolveBranding } from "@njoy/common";

import { useTenantContext } from "../tenant/TenantProvider";
import njoyLogo from "../assets/images/logo.png";

/** The site's name and logo: the tenant's, or njoy's where it sets none. */
export const useBrand = () => {
  const { config } = useTenantContext();
  const brand = resolveBranding(config?.branding);
  return { ...brand, logoUrl: brand.logoUrl || njoyLogo, isCustomLogo: Boolean(brand.logoUrl) };
};
